/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import Modal from '/client/src/components/Modal';
import { CTooltip, CTooltipLabel, CTooltipText } from '/client/src/components/tooltip/';
import { PUT } from '/client/src/api';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { setValidateClass } from '/client/src/utils/animation';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { timeerOffModal } from '/client/src/constants/';
import { emailRegexp } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
};

class EditProfileModal extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  state = {
    firstname: '',
    lastname: '',
    email: '',
    phone: '',
    firstnameNotValid: false,
    lastnameNotValid: false,
    emailNotValid: false,
    phoneNotValid: false,
    isLocked: false
  };

  componentDidMount() {
    const profileData = this.context.profileCurrent;

    this.setProfileData(profileData);
  }

  setProfileData = (profileData: {}) => {
    this.setState({
      firstname: _.get(profileData, 'first_name', ''),
      lastname: _.get(profileData, 'last_name', ''),
      email: _.get(profileData, 'email', ''),
      phone: _.get(profileData, 'phone_number', ''),
      firstnameNotValid: !_.size(_.get(profileData, 'first_name', '')),
      lastnameNotValid: !_.size(_.get(profileData, 'last_name', '')),
      emailNotValid: !_.size(_.get(profileData, 'email', '')),
      phoneNotValid: !_.size(_.get(profileData, 'phone_number', ''))
    });
  }

  handleClose = (): any => {
    const { handleToggleEditProfileModal } = this.context;

    handleToggleEditProfileModal(false);
  };

  handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
    const name = e.target.id;
    const value = e.target.value;
    const el = e.target;

    this.setState({
      [name]: value
    }, () => {
      this.validate(el);
    });
  };

  validate = (el: HTMLInputElement) => {
    const _name = `${el.id}NotValid`;

    this.setState({
      [_name]: el.id === 'email' ? !emailRegexp.test(el.value) : !_.size(el.value)
    }, () => {
      // Validate and shake if field is empty
      setValidateClass(el);
    });
  }

  handleSaveProfileData = async (setStatus: (string) => void) => {
    const {
      isLocked,
      firstnameNotValid,
      lastnameNotValid,
      emailNotValid,
      phoneNotValid
    } = this.state;

    if (isLocked) {
      return;
    }

    if (firstnameNotValid || lastnameNotValid || emailNotValid || phoneNotValid) {
      setValidateClass(this.firstname);
      setValidateClass(this.lastname);
      setValidateClass(this.email);
      setValidateClass(this.phone);
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    const data = {
      'first_name': this.state.firstname,
      'last_name': this.state.lastname,
      'email': this.state.email,
      'phone_number': this.state.phone
    };

    try {
      const { success } = await PUT('/api/v1/1/merchants/basic_info_app', data);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');
          this.context.handleGetProfile();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Profile saved'
          });
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Can\'t save profile'
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 2);
      });
    }
  }

  render(): React.Element {
    const { isOpen } = this.props;
    const {
      firstname,
      firstnameNotValid,
      lastname,
      lastnameNotValid,
      email,
      emailNotValid,
      phone,
      phoneNotValid,
      isLocked
    } = this.state;

    return (
      <>
        {isOpen ?
          <Modal
            opened={isOpen}
            onClose={this.handleClose}
          >
            <div className="modal-dialog customModal EditProfileModal" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Edit Profile</h4>
                </div>
                <div className="modal-body" style={{ cursor: isLocked ? 'not-allowed' : 'auto' }}>

                  <form style={{ pointerEvents: isLocked ? 'none' : 'auto' }}>
                    <div className="form-group">
                      <label htmlFor="firstname">First Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id='firstname'
                        value={firstname}
                        onChange={this.handleChangeInput}
                        ref={((node: HTMLInputElement) => {
                          this.firstname = node;
                        })}
                      />

                      {firstnameNotValid ?
                        <span
                          className="validationMessage"
                        >This field is required.</span> :
                        null
                      }
                    </div>

                    <div className="form-group">
                      <label htmlFor="lastname">Last Name</label>

                      <input
                        type="text"
                        className="form-control"
                        id='lastname'
                        value={lastname}
                        onChange={this.handleChangeInput}
                        ref={((node: HTMLInputElement) => {
                          this.lastname = node;
                        })}
                      />

                      {lastnameNotValid ?
                        <span
                          className="validationMessage"
                        >This field is required.</span> :
                        null
                      }
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email</label>

                      <input
                        type="email"
                        className="form-control"
                        id='email'
                        value={email}
                        onChange={this.handleChangeInput}
                        ref={((node: HTMLInputElement) => {
                          this.email = node;
                        })}
                      />

                      {emailNotValid ?
                        <span
                          className="validationMessage"
                        >Email is not valid</span> :
                        null
                      }
                    </div>

                    <div className="form-group">
                      <label htmlFor="phone">
                        Phone Number
                        <CTooltip>
                          <CTooltipLabel standart>?</CTooltipLabel>
                          <CTooltipText>Include area code</CTooltipText>
                        </CTooltip>
                      </label>

                      <input
                        type="phonenumber"
                        className="form-control"
                        id='phone'
                        value={phone}
                        onChange={this.handleChangeInput}
                        ref={((node: HTMLInputElement) => {
                          this.phone = node;
                        })}
                      />

                      {phoneNotValid ?
                        <span
                          className="validationMessage"
                        >This field is required.</span> :
                        null
                      }
                    </div>
                  </form>

                </div>
                <div className="modal-footer">
                  <button className="btn btn-gray" onClick={this.handleClose}>Close</button>
                  <span className='custom-pb-container'>
                    <BtnLoader
                      label='Save'
                      handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                        this.handleSaveProfileData(setStatus);
                      }}
                    />
                  </span>

                  {/* <button className="btn btn-pink" onClick={this.handleSaveProfileData}>Save</button> */}
                </div>
              </div>
            </div>
          </Modal>
        : null}
      </>

    );
  }
}

export default EditProfileModal;
